import { render, staticRenderFns } from "./gameMg.vue?vue&type=template&id=1d8a8038&scoped=true&"
import script from "./gameMg.vue?vue&type=script&lang=js&"
export * from "./gameMg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a8038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8a8038')) {
      api.createRecord('1d8a8038', component.options)
    } else {
      api.reload('1d8a8038', component.options)
    }
    module.hot.accept("./gameMg.vue?vue&type=template&id=1d8a8038&scoped=true&", function () {
      api.rerender('1d8a8038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/googleAds/gameMg.vue"
export default component.exports